import { createFileRoute } from '@tanstack/react-router'
import { Narasi } from '../pages/Narasi'

export const Route = createFileRoute('/narasi')({
  component: Narasi,
})
